export default __webpack_public_path__ + "static/media/to_delete4.b599d8b6.png";